// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__26wAk","header":"MergedInvoice_header__PdzDN"};